export enum PersonalDataCheckboxVariant {
  Agreement = 'agreement',
  Receiving = 'receiving'
}
